/* eslint-disable react/jsx-pascal-case */
import React, { useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { HtmlToolTip } from 'assets/ToolTips'
import A_IconMust from '../A_IconMust'
import { moleculeLog } from 'utils/logUtil'
import { codeBoxInfo } from 'types/FunctionTypes'
import '../textBox.css'

type Props = {
  key?: number
  tab?: number
  info: codeBoxInfo
  must?: boolean
  focus?: boolean
  register?: {
    onKeyDown({ key }: { key: string }): void
    ref(element: HTMLInputElement | null): void
  }
  type?: string
}

const CODE_WIDTH = '25%' // コード入力欄の幅
const NAME_WIDTH = '70%' // 名称表示欄の幅

const M_FieldCodeBox = ({
  key = 0, //
  tab = -1,
  info,
  must = false,
  focus = false,
  register,
  type = 'number',
}: Props) => {
  useEffect(() => moleculeLog('M_FieldCodeBox'))
  const max = 100
  const error = info.error
  return (
    <Grid container justifyContent="flex-start">
      <Grid item xs={3}>
        <Typography variant="body1" display="block" gutterBottom>
          {info.label}
          <A_IconMust must={must} />
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <input
          key={key} //
          tabIndex={tab}
          type={type}
          style={{ width: CODE_WIDTH }}
          value={info.code}
          onChange={info.change}
          onKeyDown={info.submit}
          autoFocus={focus}
          {...register}
          maxLength={max}
          disabled={info.disabled}
        />
        {info.name && info.name.length <= 0 ? (
          <input type="text" style={{ width: NAME_WIDTH }} value={info.name} disabled />
        ) : (
          <HtmlToolTip //
            title={<Typography variant="button">{info.name}</Typography>}
            placement="bottom-start"
          >
            {!error ? (
              <input
                type="text" //
                style={{ width: NAME_WIDTH }}
                value={info.name}
                disabled
              />
            ) : (
              <input
                type="text" //
                style={{ width: NAME_WIDTH, backgroundColor: 'red', color: 'yellow' }}
                value={info.name}
                disabled
              />
            )}
          </HtmlToolTip>
        )}
      </Grid>
    </Grid>
  )
}
export default React.memo(M_FieldCodeBox)
